/**
 * Whether the toolbar renders the CSV uploader. Hidden in view-only mode —
 * except while this tab's own upload runs (PSTUDIO-4452): a live import locks
 * the document, which turns the table view-only, and the uploader owns the
 * portal-rendered confirmation modal; unmounting it mid-upload stranded that
 * modal open over the page.
 */
export const showCsvUploader = ({
  viewOnly,
  uploading,
}: {
  viewOnly: boolean;
  uploading: boolean;
}): boolean => !viewOnly || uploading;

/**
 * Runs an upload with the "uploading" flag held for exactly its duration.
 * Cleared in `finally`: `handleUpload` returns early without calling its
 * success callback (no draft id yet), and a flag left on would keep the
 * uploader shown to a viewer for the rest of the session.
 */
export const whileCsvUploading = async (
  setUploading: (uploading: boolean) => void,
  upload: () => Promise<void>
): Promise<void> => {
  setUploading(true);
  try {
    await upload();
  } finally {
    setUploading(false);
  }
};
